import type { DefaultProps } from 'typings'
import * as styles from './stackedBoxes.css'

export function StackedBoxes(props: DefaultProps) {
  return <div className={styles.stacked}>{props.children}</div>
}
